<template>
<div class="chapter">
<div class="inner_page">
<div class="cover" id="cover">
<h1 class="title">
				IN PLAIN SIGHT
			</h1>
<h3 class="subtitle">
<div class="author_info">
<p class="author">
					MIKE KNOWLES
				</p>
</div>
<p class="publisher">
				ECW Press
			</p>
</h3></div>
<div class="footnote" id="prelim_footnotes">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3e88da7f